<template>
  <div>
    <DynamicComponent edc-id="polaris-task" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'PolarisTask',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
